export const ADD = 'entities/budget/ADD';
export const ADD_MULTIPLE = 'entities/budget/ADD_MULTIPLE';
export const UPDATE = 'entities/budget/UPDATE';
export const REMOVE = 'entities/budget/REMOVE';
